import { render } from "./TermsOfUsePage.vue?vue&type=template&id=3d29fef8&scoped=true"
import script from "./TermsOfUsePage.vue?vue&type=script&lang=js"
export * from "./TermsOfUsePage.vue?vue&type=script&lang=js"

import "./TermsOfUsePage.vue?vue&type=style&index=0&id=3d29fef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d29fef8"]])

export default __exports__